module.exports = __webpack_public_path__ + "static/media/logo02.6fe806b8.png";